import React from "react";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
	VALIDATOR_NUMBER_ONLY,
	VALIDATOR_REQUIRE,
} from "../../shared/util/validators";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch } from "react-redux";
import uuid from "react-uuid";

const AddMinorModal = (props) => {
	const dispatch = useDispatch();

	const [formState, inputHandler] = useForm(
		{
			title: {
				value: "",
				isValid: false,
			},
			count: {
				value: "",
				isValid: false,
			},
			totalPrice: {
				value: "",
				isValid: false,
			},
			discountPrice: {
				value: "",
				isValid: false,
			},
		},
		false
	);

	const receiptMinorChangeHandler = (event) => {
		event.preventDefault();
		dispatch({
			type: "addDetail",
			payload: {
				orderId: props.orderId,
				detail: {
					id: uuid(),
					title: formState.inputs.title.value,
					count: formState.inputs.count.value,
					totalPrice: Number(formState.inputs.totalPrice.value),
					discountPrice: Number(formState.inputs.discountPrice.value),
					submissionDate: new Date().getTime(),
				},
			},
		});

		props.close();
	};

	return (
		<React.Fragment>
			<form onSubmit={receiptMinorChangeHandler}>
				<Paper
					sx={{ flexGrow: 1, maxWidth: 1200, p: 2, m: 1 }}
					elevation={2}
				>
					<Grid container spacing={1}>
						<Grid md={6} xs={12}>
							<Input
								id="title"
								element="input"
								label="عنوان"
								validators={[VALIDATOR_REQUIRE()]}
								errorText="لطفا عنوان را وارد کنید"
								onInput={inputHandler}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="count"
								element="number_only"
								label="تعداد"
								validators={[
									VALIDATOR_REQUIRE(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا تعداد را وارد کنید"
								onInput={inputHandler}
								type="text"
								inputProps={{ min: 0 }}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="totalPrice"
								element="number_only"
								label="قیمت کل"
								validators={[
									VALIDATOR_REQUIRE(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا قیمت کل را وارد کنید"
								onInput={inputHandler}
								type="text"
								inputProps={{ min: 0 }}
								needsThousandSeparator
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="discountPrice"
								element="number_only"
								label="قیمت پس از تخفیف"
								validators={[
									VALIDATOR_REQUIRE(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا قیمت پس از تخفیف را وارد کنید"
								onInput={inputHandler}
								type="text"
								inputProps={{ min: 0 }}
								needsThousandSeparator
							/>
						</Grid>
						<Grid xs={12} md={6}>
							<Button
								disabled={!formState.isValid}
								type="submit"
								fullWidth
								color="secondary"
								variant="contained"
							>
								<EditIcon />
							</Button>
						</Grid>
						<Grid xs={12} md={6}>
							<Button
								fullWidth
								color="primary"
								variant="contained"
								onClick={props.close}
							>
								<ArrowBackIcon />
							</Button>
						</Grid>
					</Grid>
				</Paper>
			</form>
		</React.Fragment>
	);
};

export default AddMinorModal;
